import * as React from 'react'
import { Typography, Box } from 'cs-kevlar-react'
import {
  makeStyles,
  createStyles,
  Theme,
} from 'cs-kevlar-react/lib/es/theming/theme'

interface LicenseMigrationInProgressProps {
  refresh: () => void
  children: any
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      padding: theme.spacing(8),
      overflowY: 'auto',
    },
  }),
)

export const LicenseMigrationInProgress: React.FunctionComponent<LicenseMigrationInProgressProps> = ({
  refresh,
  children,
}) => {
  const classes = useStyles({})

  React.useEffect(() => {
    const interval = setInterval(refresh, 5000)

    return () => {
      clearInterval(interval)
    }
  }, [])

  return (
    <React.Fragment>
      <Box className={classes.content}>
        <Typography>License migration is currently in progress...</Typography>
      </Box>
      {children}
    </React.Fragment>
  )
}
